import moment from 'moment';

const ISO_8601 =
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?/g;

const parseAsUtc = (value: string): Date =>
  new Date(/(?:Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`);

const TIMESTAMP_FORMAT = 'MMM D, YYYY · hh:mm:ss A';

export const localizeMessageTimestamps = (text: string): string =>
  text.replace(ISO_8601, (match) => {
    const date = parseAsUtc(match);
    return Number.isNaN(date.getTime())
      ? match
      : moment(date).format(TIMESTAMP_FORMAT);
  });
